<div class="numero-diente">{{diente.numero}}</div>
<div class="checkbox-diente"><input [disabled]="disabled" type="checkbox" [(ngModel)]="diente.selected" (change)="changeDiente($event)"/></div>